@if (score?.currentlyServing) {
    <div class="column serving">
        <div class="cell"><span class="serving-indicator" *ngIf="score?.currentlyServing === 1"></span></div>
        <div class="cell"><span class="serving-indicator" *ngIf="score?.currentlyServing === 2"></span></div>
    </div>
}
@if (points) {
    <div class="column" [ngClass]="hasExtended ? 'swap-points-column current-set' : 'divider'">
        <div class="cell">
            <div [msValueSlider]="points.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="points.participant2.toString()"></div>
        </div>
        <div class="cell" *ngIf="!hideScoreBoardColumnFooter">{{ scoreboardP }}</div>
    </div>
}
@if (frames) {
    <div class="column sets" [class.divider]="hasExtended">
        <div class="cell">
            <div [msValueSlider]="frames.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="frames.participant2.toString()"></div>
        </div>
        <div class="cell" *ngIf="!hideScoreBoardColumnFooter">{{ scoreboardF }}</div>
    </div>
}
w
